<template>
	<v-layout column>
		<div>
			<v-card-title>
				<h2>Formularze ofertowe</h2>
			</v-card-title>
		</div>
		
		<v-layout row wrap mb-3>
			<v-flex xs6>
				<contest-forms-view-item
					:disabled="contestData.announced"
					:form-defined="formStatus.contestFormDefined"
					:checkbox="checkboxOfferForm"
					v-on:form-deleted="formDeleted"
					v-on:form-chosen="formChosen"
				></contest-forms-view-item>
			</v-flex>
			<v-flex xs6>
				<contest-forms-view-item
					:disabled="contestData.announced"
					:form-defined="formStatus.contestModuleFormDefined"
					:checkbox="checkboxModuleForm"
					v-on:form-deleted="formDeleted"
					v-on:form-chosen="formChosen"
				></contest-forms-view-item>
			</v-flex>
		</v-layout>

		<v-divider/>
		<div>
			<v-card-title>
				<h2>Formularze ocen i opinii</h2>
			</v-card-title>
		</div>
		<v-layout row wrap mb-3>
			<v-flex xs6>
				<contest-forms-view-item
					:disabled="contestData.evaluationOpen"
					:form-defined="formStatus.formalEvaluationFormDefined"
					:checkbox="checkboxFormal"
					v-on:form-deleted="formDeleted"
					v-on:form-chosen="formChosen"
				></contest-forms-view-item>
			</v-flex>
			<v-flex xs6>
				<contest-forms-view-item
					:disabled="contestData.evaluationOpen"
					:form-defined="formStatus.individualEvaluationFormDefined"
					:checkbox="checkboxIndividual"
					v-on:form-deleted="formDeleted"
					v-on:form-chosen="formChosen"
				></contest-forms-view-item>
			</v-flex>
			<v-flex xs6>
				<contest-forms-view-item
					:disabled="contestData.evaluationOpen"
					:form-defined="formStatus.agencyEvaluationFormDefined"
					:checkbox="checkboxAgency"
					v-on:form-deleted="formDeleted"
					v-on:form-chosen="formChosen"
				></contest-forms-view-item>
			</v-flex>
			<v-flex xs6>
				<contest-forms-view-item
					:disabled="contestData.evaluationOpen"
					:form-defined="formStatus.expertEvaluationFormDefined"
					:checkbox="checkboxExpert"
					v-on:form-deleted="formDeleted"
					v-on:form-chosen="formChosen"
				></contest-forms-view-item>
			</v-flex>
			<v-flex xs6>
				<contest-forms-view-item
					:disabled="contestData.evaluationOpen"
					:form-defined="formStatus.committeeCollaborationEvaluationFormDefined"
					:checkbox="checkboxCommitteeCollab"
					v-on:form-deleted="formDeleted"
					v-on:form-chosen="formChosen"
				></contest-forms-view-item>
			</v-flex>
			<v-flex xs6>
				<contest-forms-view-item
					:disabled="contestData.evaluationOpen"
					:form-defined="formStatus.finalEvaluationFormDefined"
					:checkbox="checkboxFinal"
					v-on:form-deleted="formDeleted"
					v-on:form-chosen="formChosen"
				></contest-forms-view-item>
			</v-flex>
		</v-layout>

		<v-divider/>
		
		<div>
			<v-card-title>
				<h2>Formularze raportów</h2>
				<v-spacer></v-spacer>
			</v-card-title>
		</div>
			

		<v-layout row wrap>
			<v-flex xs6>
				<contest-forms-view-item
					:disabled="contestData.hasAnyMonitoringReportGenerated"
					:form-defined="formStatus.monitoringReportFormDefined"
					:checkbox="monitoringReportCheckbox"
					v-on:form-deleted="formDeleted"
					v-on:form-chosen="formChosen"
				></contest-forms-view-item>
			</v-flex>
			<v-flex xs6>
				<contest-forms-view-item
					:disabled="contestData.hasAnyCollaborationEvaluationGenerated"
					:form-defined="formStatus.collaborationEvaluationFormDefined"
					:checkbox="checkboxCollab"
					v-on:form-deleted="formDeleted"
					v-on:form-chosen="formChosen"
				></contest-forms-view-item>
			</v-flex>
		</v-layout>
		<v-layout>
			<h4 class="mt-4" v-if="reportCheckboxList.length > 0">Raporty wolontariuszy</h4>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs6 v-for="(reportCheckbox, index) in reportCheckboxList" :key="index">
				<contest-forms-view-item
					:disabled="contestData.hasAnyVolunteerReportGenerated"
					:form-defined="reportCheckbox.formDefined"
					:checkbox="reportCheckbox"
					v-on:form-deleted="formDeleted"
					v-on:form-chosen="formChosen"
				></contest-forms-view-item>
			</v-flex>
		</v-layout>
			
		<v-card-title class="mt-4">
			<h2>Sprawozdanie końcowe</h2>
			<v-spacer></v-spacer>
		</v-card-title>
			
		<v-layout row wrap>
			<v-flex xs6>
				<contest-forms-view-item
					:form-defined="formStatus.finalReportFormDefined"
					:checkbox="finalReportCheckbox"
					v-on:form-deleted="formDeleted"
					v-on:form-chosen="formChosen"
				></contest-forms-view-item>
			</v-flex>
		</v-layout>

	</v-layout>
</template>

<script>
	import {PublicContest} from "@/api/generated/PublicContest";
	import ContestFormsViewItem from "./ContestFormsViewItem";

	export default {
		name: "ContestFormsViewPanel",
		components: {ContestFormsViewItem},

		data() {
			return {
				contestData: {
					id: this.$route.params.id,
					announced: undefined,
					evaluationOpen: undefined,
					hasAnyVolunteerReportGenerated: undefined,
					hasAnyMonitoringReportGenerated: undefined,
					hasAnyCollaborationEvaluationGenerated: undefined
				},

				formStatus: {
					contestFormDefined: false,
					contestModuleFormDefined: false,
					formalEvaluationFormDefined: false,
					individualEvaluationFormDefined: false,
					agencyEvaluationFormDefined: false,
					expertEvaluationFormDefined: false,
					finalEvaluationFormDefined: false,
					collaborationEvaluationFormDefined: false,
					committeeCollaborationEvaluationFormDefined: false,
					monitoringReportFormDefined: false,
					finalReportFormDefined: false
				},

				volunteerReportTerms: [],

				checkboxOfferForm: {
					status: true,
					isDisabled: true,
					text: "Formularz oferty",
					formType: "OFFER",
				},

				checkboxModuleForm: {
					status: true,
					isDisabled: true,
					text: "Formularz oferty (powtarzany na każdy moduł)",
					formType: "MODULE_OFFER",
				},

				checkboxFormal: {
					status: false,
					isDisabled: false,
					text: "Opinia formalna",
					formType: "FORMAL_EVALUATION",
				},

				checkboxIndividual: {
					status: false,
					isDisabled: false,
					text: "Indywidualna opinia członka komisji",
					scoreDifference: 0,
					formType: "INDIVIDUAL_EVALUATION",
				},

				checkboxAgency: {
					status: false,
					isDisabled: false,
					text: "Opinia placówki",
					formType: "AGENCY_EVALUATION",
				},

				checkboxExpert: {
					status: false,
					isDisabled: false,
					text: "Opinia eksperta",
					formType: "EXPERT_EVALUATION",
				},

				checkboxCollab: {
					status: true,
					isDisabled: true,
					text: "Ocena współpracy przez opiekuna",
					formType: "COLLABORATION_EVALUATION",
				},

				checkboxCommitteeCollab: {
					status: false,
					isDisabled: false,
					text: "Ocena współpracy przez komisję",
					formType: "COMMITTEE_COLLABORATION_EVALUATION",
				},

				checkboxFinal: {
					status: true,
					isDisabled: true,
					text: "Opinia końcowa",
					formType: "FINAL_EVALUATION",
				},

				reportCheckboxList: [],

				reportCheckbox: {
					id: null,
					date: "",
					status: false,
					formDefined: false,
					isDisabled: false,
					text: "",
					formType: "volunteer-report"
				},

				monitoringReportCheckbox: {
					status: true,
					isDisabled: true,
					text: "Raporty z monitoringu",
					formType: "MONITORING_REPORT",
				},

				finalReportCheckbox: {
					status: true,
					isDisabled: true,
					text: "Sprawozdanie końcowe",
					formType: "FINAL_REPORT",
				}
			};
		},

		methods: {
			setFormStatus (schemaSet) {
				this.formStatus.contestFormDefined = schemaSet.offerSchema !== null;
				this.formStatus.contestModuleFormDefined = schemaSet.moduleSchema !== null;
				this.formStatus.formalEvaluationFormDefined = schemaSet.formalEvaluationSchema !== null;
				this.formStatus.individualEvaluationFormDefined = schemaSet.individualEvaluationSchema !== null;
				this.formStatus.agencyEvaluationFormDefined = schemaSet.agencyEvaluationSchema !== null;
				this.formStatus.expertEvaluationFormDefined = schemaSet.expertEvaluationSchema !== null;
				this.formStatus.finalEvaluationFormDefined = schemaSet.finalEvaluationSchema !== null;
				this.formStatus.collaborationEvaluationFormDefined = schemaSet.collaborationEvaluationSchema !== null;
				this.formStatus.committeeCollaborationEvaluationFormDefined = schemaSet.committeeCollaborationEvaluationSchema !== null;
				this.formStatus.monitoringReportFormDefined = schemaSet.monitoringReportSchema !== null;
				this.formStatus.finalReportFormDefined = schemaSet.finalReportSchema !== null;

				this.checkboxFormal.status = schemaSet.formalEvaluationSchemaIncluded;
				this.checkboxAgency.status = schemaSet.agencyEvaluationSchemaIncluded;
				this.checkboxIndividual.status = schemaSet.individualEvaluationSchemaIncluded;
				this.checkboxExpert.status = schemaSet.expertEvaluationSchemaIncluded;
				this.checkboxCollab.status = true;
				this.checkboxCommitteeCollab.status = schemaSet.committeeCollaborationEvaluationSchemaIncluded;
				this.monitoringReportCheckbox.status = schemaSet.monitoringReportSchemaIncluded;
				this.finalReportCheckbox.status = schemaSet.finalReportSchemaIncluded;
			},

			setReportFormStatus () {
				this.volunteerReportTerms.forEach(report => {
					let formattedDate = this.getFormattedDate(report.reportDate);
					let checkbox = {
						id: report.id,
						date: formattedDate,
						status: true,
						formDefined: report.volunteerReportSchema !== null,
						isDisabled: true,
						text: this.getFormattedText(report.term, formattedDate),
						formType: "volunteer-report"
					};
					this.reportCheckboxList.push(checkbox);
				});
			},

			getFormattedDate (date) {
				if (date !== null && date !== undefined) {
					let year = date[0];
					let month = date[1] < 10 ? '0' + date[1] : date[1];
					let day = date[2] < 10 ? '0' + date[2] : date[2];
					return year + "-" + month + "-" + day;
				} else return "";
			},

			getFormattedText (term, formattedDate) {
				let s = "Raport wolontariusza: Termin " + term;
				if (formattedDate !== "") {
					return s + " (" + formattedDate + ")";
				}
				return s;
			},

			formDeleted() {
				this.$emit("form-deleted");
			},

			formChosen() {
				this.$emit("form-chosen");
			},
		},

		mounted() {
			PublicContest.getFormStatus(this, this.$route.params.id, response => {
				this.setFormStatus(response.contestSchemaSet);
			});

			PublicContest.getGeneralSettings(this, this.$route.params.id, response => {
				this.checkboxModuleForm.status = response.modularOfferSettings.modularOffersEnabled;
			});

			PublicContest.getVolunteerReportForms(this, this.$route.params.id, successResponse => {
					this.volunteerReportTerms = successResponse;
					this.volunteerReportTerms.sort(function (x, y) {
						return x.term - y.term;
					});
					this.setReportFormStatus();
				},
				errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się załadować formularzy raportów", errorResponse);
				});
		},

		created () {
			PublicContest.getStatus(this, this.contestData.id, response => {
				this.contestData = response;
			});
		}
	};
</script>

<style scoped>

</style>
